import React from "react";

const WardList = ({ items, onSelected }) => {
	const list = items || [];
	return (
		<div className="table-responsive">
			<table className="table table-hover table-bordered">
				<thead>
					<tr>
						<th>sn</th>
						<th>Name</th>
						<th className="text-right"> Date Created</th>
					</tr>
				</thead>
				<tbody>
					{list.map((item, index) => (
						<tr key={index} onClick={() => onSelected(item)}>
							<td className="inbox-small-cells">
								<div className="todo-check pull-left">
									{index + 1}
								</div>
							</td>
							<td className="view-message">
								<h5>{item.name}</h5>
								<p>{item.description || "No Description!"}</p>
							</td>
							<td className="view-message text-right">
								{new Date(
									parseInt(item.created_at)
								).toLocaleDateString("en-GB")}
							</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default WardList;
